import React, { useState } from 'react';
import EnterWeightModal from './modals/EnterWeightModal';

/**
 * Tile grid for the synthetic "Price by Weight" category tab (see Takeaway.js) - deliberately
 * separate from TakeawayMenuList.js rather than forcing weighted products through its real-dish
 * rendering (sizes, thumbnails, force_customization_popup branching). Every tile always opens
 * the weight-entry modal; there's no direct-add / customisation-popup branch here since a
 * weighted product always needs a weight before it has a price.
 */
const WeightedProductsList = ({ products, orderType, editOrderId, onCartChange, placeholderItemId }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  if (!products || products.length === 0) {
    return <p className="text-center" style={{ opacity: 0.7 }}>No weighted products configured yet.</p>;
  }

  return (
    <>
      <div className="row g-3">
        {products.map((product) => (
          <div className="col-6 col-md-4 col-lg-3" key={product.id}>
            <button
              type="button"
              className="btn btn-secondary w-100 h-100 py-3"
              onClick={() => setSelectedProduct(product)}
            >
              <span className="d-block fw-bold">{product.name}</span>
              <span className="d-block" style={{ fontSize: '12px', opacity: 0.8 }}>
                ${Number(product.price_per_unit).toFixed(2)} / {product.pricing_unit_denominator}{product.weight_unit}
              </span>
            </button>
          </div>
        ))}
      </div>

      <EnterWeightModal
        isOpen={!!selectedProduct}
        product={selectedProduct}
        placeholderItemId={placeholderItemId}
        orderType={orderType}
        editOrderId={editOrderId}
        onClose={() => setSelectedProduct(null)}
        onAdded={() => {
          setSelectedProduct(null);
          if (onCartChange) onCartChange();
        }}
      />
    </>
  );
};

export default WeightedProductsList;
